/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import {
  RECEIVE_BADGE_SCAN_EXTRA_QUESTION,
  RESET_BADGE_SCAN_EXTRA_QUESTION_FORM,
  BADGE_SCAN_EXTRA_QUESTION_VALUE_ADDED,
  BADGE_SCAN_EXTRA_QUESTION_VALUE_UPDATED,
  BADGE_SCAN_EXTRA_QUESTION_VALUE_DELETED,
  BADGE_SCAN_EXTRA_QUESTION_VALUE_ORDER_UPDATED,
  RECEIVE_BADGE_SCAN_EXTRA_QUESTIONS_META,
  BADGE_SCAN_EXTRA_QUESTION_ADDED,
  BADGE_SCAN_EXTRA_QUESTION_UPDATED
} from "../actions/sponsor-actions";

export const DEFAULT_ENTITY = {
  id: 0,
  name: "",
  label: "",
  type: null,
  mandatory: false,
  placeholder: "",
  values: []
};

const DEFAULT_STATE = {
  entity: DEFAULT_ENTITY,
  allClasses: []
};

const sponsorBadgeScansExtraQuestion = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case RESET_BADGE_SCAN_EXTRA_QUESTION_FORM: {
      return { ...state, entity: { ...DEFAULT_ENTITY } };
    }
    case RECEIVE_BADGE_SCAN_EXTRA_QUESTIONS_META: {
      const allClasses = payload.response;

      return { ...state, allClasses };
    }
    case BADGE_SCAN_EXTRA_QUESTION_ADDED:
    case BADGE_SCAN_EXTRA_QUESTION_UPDATED:
    case RECEIVE_BADGE_SCAN_EXTRA_QUESTION: {
      const raw = payload.response ?? {};
      const entity = {
        ...DEFAULT_ENTITY,
        ...raw,
        name: raw.name ?? "",
        label: raw.label ?? "",
        placeholder: raw.placeholder ?? "",
        mandatory: Boolean(raw.mandatory),
        values: raw.values ?? []
      };

      return { ...state, entity };
    }
    case BADGE_SCAN_EXTRA_QUESTION_VALUE_ADDED: {
      const entity = { ...payload.response };
      let values = [...state.entity.values];
      if (entity.is_default) {
        values = values.map((v) => ({ ...v, is_default: false }));
      }

      return {
        ...state,
        entity: { ...state.entity, values: [...values, entity] }
      };
    }
    case BADGE_SCAN_EXTRA_QUESTION_VALUE_UPDATED: {
      const entity = { ...payload.response };
      let values_tmp = state.entity.values.filter((v) => v.id !== entity.id);
      if (entity.is_default) {
        values_tmp = values_tmp.map((v) => ({ ...v, is_default: false }));
      }
      const values = [...values_tmp, entity];

      values.sort((a, b) =>
        a.order > b.order ? 1 : a.order < b.order ? -1 : 0
      );

      return { ...state, entity: { ...state.entity, values } };
    }
    case BADGE_SCAN_EXTRA_QUESTION_VALUE_ORDER_UPDATED: {
      const { id, order } = payload ?? {};
      if (!id) return state;
      const values = state.entity.values
        .map((v) => (v.id === id ? { ...v, order } : v))
        .sort((a, b) => (a.order > b.order ? 1 : a.order < b.order ? -1 : 0));
      return { ...state, entity: { ...state.entity, values } };
    }
    case BADGE_SCAN_EXTRA_QUESTION_VALUE_DELETED: {
      const { valueId } = payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          values: state.entity.values.filter((v) => v.id !== valueId)
        }
      };
    }
    default:
      return state;
  }
};

export default sponsorBadgeScansExtraQuestion;
